import { USER_INFO } from "../..";
import { getCall, postCall } from "../../utils/apiCalls";

const API_ENDPOINTS = {
  FETCH_USER: "/v1/bus/fetch-user-id",
  REGISTER_EMAIL: "/v1/bus/auth/register",
};

/**
 * Fetches user details from the API
 * @returns {Promise<Object>} User details
 * @throws {Error} If API call fails
 */
export const getSSO_TokenEnc = () => {
  const userData = localStorage.getItem(USER_INFO);
  const parsedUserData = userData ? JSON.parse(userData) : null;
  return parsedUserData && parsedUserData.user && parsedUserData.user.sso_token_enc;
};

export const fetchUser = async () => {
  try {
    const response = await getCall(
      API_ENDPOINTS.FETCH_USER,
      {}, // query params
      [], // essentialParams
      {
        // extraHeaders
        sso_token_enc: getSSO_TokenEnc(),
      }
    );

    if (!response.data) {
      console.error("No data received from server");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching user details:", error);
    throw error;
  }
};

/**
 * Submits email for registration
 * @param {string} email - Email to register
 * @returns {Promise<Object>} Registration response
 * @throws {Error} If API call fails
 */
export const submitEmail = async (email) => {
  try {
    if (!email) {
      console.error("Email is required");
      return null;
    }

    const response = await postCall(
      API_ENDPOINTS.REGISTER_EMAIL,
      { email },
      false, // skipTokenCheck
      {
        sso_token_enc: getSSO_TokenEnc(),
      },
      { "Content-Type": "application/json" }
    );

    // Check if we have valid data
    if (!response.data) {
      console.error("No data received from server");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Error registering email:", error);
    throw error;
  }
};
